export const isValidCountry = (countryCode: string) =>
  countryData.countries.find((c) => c.code.toLowerCase() === countryCode.toLowerCase());

export interface ICountry {
  name: string;
  code: string;
  currency?: string;
  footprint?: number;
  unitSystem?: string;
  eu?: boolean;
  label?: string;
  locale?: string;
}

export interface ICountryData {
  countries: ICountry[];
}

export const countryData: ICountryData = {
  countries: [
    {
      name: 'New Zealand',
      code: 'NZ',
      currency: 'NZD',
      footprint: 16.9,
      locale: 'en-NZ',
    },
    {
      name: 'United States',
      code: 'US',
      currency: 'USD',
      footprint: 18.1,
      unitSystem: 'IMPERIAL',
      locale: 'en-US',
    },
    {
      name: 'Australia',
      code: 'AU',
      currency: 'AUD',
      footprint: 27.67,
      locale: 'en-AU',
    },
    {
      name: 'India',
      code: 'IN',
      currency: 'INR',
      footprint: 1.9621603133683,
      locale: 'en-IN',
    },
    {
      name: 'United Kingdom',
      code: 'GB',
      currency: 'GBP',
      footprint: 7.7, //https://ourworldindata.org/grapher/consumption-co2-per-capita?country=~GBR
      locale: 'en-GB',
    },
    {
      name: 'South Africa',
      code: 'ZA',
      currency: 'ZAR',
      footprint: 8.0903569558952,
      locale: 'en-ZA',
    },
    {
      name: 'Afghanistan',
      code: 'AF',
      currency: 'AFN',
      footprint: 0.92,
      locale: 'ps-AF',
    },
    {
      name: 'Albania',
      code: 'AL',
      currency: 'ALL',
      footprint: 3.03,
      locale: 'sq-AL',
    },
    {
      name: 'Algeria',
      code: 'DZ',
      currency: 'DZD',
      footprint: 6,
      locale: 'ar-DZ',
    },
    {
      name: 'Andorra',
      code: 'AD',
      currency: 'EUR',
      footprint: 6.11523777368,
      eu: true,
      locale: 'ca-AD',
    },
    {
      name: 'Angola',
      code: 'AO',
      currency: 'AOA',
      footprint: 2.91,
      locale: 'pt-AO',
    },
    {
      name: 'Anguilla',
      code: 'AI',
      currency: 'XCD',
      footprint: 2.21,
      locale: 'en-AI',
    },
    {
      name: 'Antigua and Barbuda',
      code: 'AG',
      currency: 'XCD',
      footprint: 7.39,
      locale: 'en-AG',
    },
    {
      name: 'Argentina',
      code: 'AR',
      currency: 'ARS',
      footprint: 8.87,
      locale: 'es-AR',
    },
    {
      name: 'Armenia',
      code: 'AM',
      currency: 'AMD',
      footprint: 2.94,
      locale: 'hy-AM',
    },
    {
      name: 'Aruba',
      code: 'AW',
      currency: 'ANG',
      footprint: 9.57,
      locale: 'nl-AW',
    },
    {
      name: 'Austria',
      code: 'AT',
      currency: 'EUR',
      footprint: 9.2,
      eu: true,
      locale: 'de-AT',
    },
    {
      name: 'Azerbaijan',
      code: 'AZ',
      currency: 'AZN',
      footprint: 5.63,
      locale: 'az-AZ',
    },
    {
      name: 'Bahamas',
      code: 'BS',
      currency: 'BSD',
      footprint: 8.32,
      locale: 'en-BS',
    },
    {
      name: 'Bahrain',
      code: 'BH',
      currency: 'USD',
      footprint: 29.12,
      locale: 'ar-BH',
    },
    {
      name: 'Bangladesh',
      code: 'BD',
      currency: 'BDT',
      footprint: 1.37,
      locale: 'bn-BD',
    },
    {
      name: 'Barbados',
      code: 'BB',
      currency: 'BBD',
      footprint: 11.77,
      locale: 'en-BB',
    },
    {
      name: 'Belarus',
      code: 'BY',
      currency: 'USD',
      footprint: 15.24,
      locale: 'be-BY',
    },
    {
      name: 'Belgium',
      code: 'BE',
      currency: 'EUR',
      footprint: 10.8,
      eu: true,
      locale: 'nl-BE',
    },
    {
      name: 'Belize',
      code: 'BZ',
      currency: 'BZD',
      footprint: 2.47,
      locale: 'en-BZ',
    },
    {
      name: 'Benin',
      code: 'BJ',
      currency: 'XOF',
      footprint: 1.31,
      locale: 'fr-BJ',
    },
    {
      name: 'Bermuda',
      code: 'BM',
      currency: 'BMD',
      footprint: 7.49,
      locale: 'en-BM',
    },
    {
      name: 'Bhutan',
      code: 'BT',
      currency: 'INR',
      footprint: 3.06,
      locale: 'dz-BT',
    },
    {
      name: 'Bolivia',
      code: 'BO',
      currency: 'BOB',
      footprint: 4.83,
      locale: 'es-BO',
    },
    {
      name: 'Bosnia and Herzegovina',
      code: 'BA',
      currency: 'BAM',
      footprint: 8.72,
      locale: 'bs-BA',
    },
    {
      name: 'Botswana',
      code: 'BW',
      currency: 'BWP',
      footprint: 2.9573641966436, //Eurostats 40.41
      locale: 'en-BW',
    },
    {
      name: 'Brazil',
      code: 'BR',
      currency: 'BRL',
      footprint: 5.97,
      locale: 'pt-BR',
    },
    {
      name: 'British Virgin Islands',
      code: 'IO',
      currency: 'USD',
      footprint: 5.51,
      locale: 'en-IO',
    },
    {
      name: 'Brunei Darussalam',
      code: 'BN',
      currency: 'BND',
      footprint: 18.485277284987, //Eurostats 28.83
      locale: 'ms-BN',
    },
    {
      name: 'Bulgaria',
      code: 'BG',
      currency: 'BGN',
      footprint: 8.57,
      eu: true,
      locale: 'bg-BG',
    },
    {
      name: 'Burkina Faso',
      code: 'BF',
      currency: 'XOF',
      footprint: 1.45,
      locale: 'fr-BF',
    },
    {
      name: 'Burundi',
      code: 'BI',
      currency: 'BIF',
      footprint: 0.46,
      locale: 'fr-BI',
    },
    {
      name: 'Cambodia',
      code: 'KH',
      currency: 'KHR',
      footprint: 2.31,
      locale: 'km-KH',
    },
    {
      name: 'Cameroon',
      code: 'CM',
      currency: 'XAF',
      footprint: 2.12,
      locale: 'fr-CM',
    },
    {
      name: 'Canada',
      code: 'CA',
      currency: 'CAD',
      footprint: 21.69,
      locale: 'en-CA',
    },
    {
      name: 'Cape Verde',
      code: 'CV',
      currency: 'CVE',
      footprint: 2.25,
      locale: 'pt-CV',
    },
    {
      name: 'Cayman Islands',
      code: 'KY',
      currency: 'KYD',
      footprint: 8.82,
      locale: 'en-KY',
    },
    {
      name: 'Central African Republic',
      code: 'CF',
      currency: 'XAF',
      footprint: 2.21,
      locale: 'fr-CF',
    },
    {
      name: 'Chad',
      code: 'TD',
      currency: 'XAF',
      footprint: 1.48,
      locale: 'fr-TD',
    },
    {
      name: 'Chile',
      code: 'CL',
      currency: 'CLP',
      footprint: 6.6,
      locale: 'es-CL',
    },
    {
      name: 'China',
      code: 'CN',
      currency: 'CNY',
      footprint: 9.35,
      locale: 'zh-CN',
    },
    {
      name: 'Colombia',
      code: 'CO',
      currency: 'COP',
      footprint: 3.49,
      locale: 'es-CO',
    },
    {
      name: 'Comoros',
      code: 'KM',
      currency: 'KMF',
      footprint: 0.76,
      locale: 'ar-KM',
    },
    {
      name: 'Congo',
      code: 'CG',
      currency: 'KMF',
      footprint: 3.11,
      locale: 'fr-CG',
    },
    {
      name: 'Cook Islands',
      code: 'CK',
      currency: 'NZD',
      footprint: 2.75,
      locale: 'en-CK',
    },
    {
      name: 'Costa Rica',
      code: 'CR',
      currency: 'CRC',
      footprint: 2.65,
      locale: 'es-CR',
    },
    {
      name: "Côte d'Ivoire",
      code: 'CI',
      currency: 'XOF',
      footprint: 1.14,
      locale: 'fr-CI',
    },
    {
      name: 'Croatia',
      code: 'HR',
      currency: 'HRK',
      footprint: 6.1,
      eu: true,
      locale: 'hr-HR',
    },
    {
      name: 'Cuba',
      code: 'CU',
      currency: 'USD',
      footprint: 4.5,
      locale: 'es-CU',
    },
    {
      name: 'Cyprus',
      code: 'CY',
      currency: 'USD',
      footprint: 6.78,
      eu: true,
      locale: 'el-CY',
    },
    {
      name: 'Czech Republic',
      code: 'CZ',
      currency: 'CZK',
      footprint: 12.2,
      eu: true,
      locale: 'cs-CZ',
    },
    {
      name: 'Democratic Republic of the Congo',
      code: 'CD',
      currency: 'XAF',
      footprint: 0.53,
      locale: 'fr-CD',
    },
    {
      name: 'Denmark',
      code: 'DK',
      currency: 'DKK',
      footprint: 8.9,
      eu: true,
      locale: 'da-DK',
    },
    {
      name: 'Djibouti',
      code: 'DJ',
      currency: 'DJF',
      footprint: 2.15,
      locale: 'fr-DJ',
    },
    {
      name: 'Dominica',
      code: 'DM',
      currency: 'XCD',
      footprint: 2.65,
      locale: 'en-DM',
    },
    {
      name: 'Dominican Republic',
      code: 'DO',
      currency: 'DOP',
      footprint: 3.32,
      locale: 'es-DO',
    },
    {
      name: 'Ecuador',
      code: 'EC',
      currency: 'USD',
      footprint: 4.37,
      locale: 'es-EC',
    },
    {
      name: 'Egypt',
      code: 'EG',
      currency: 'EGP',
      footprint: 3.44,
      locale: 'ar-EG',
    },
    {
      name: 'El Salvador',
      code: 'SV',
      currency: 'USD',
      footprint: 1.85,
      locale: 'es-SV',
    },
    {
      name: 'Equatorial Guinea',
      code: 'GQ',
      currency: 'XAF',
      footprint: 6.37,
      locale: 'es-GQ',
    },
    {
      name: 'Eritrea',
      code: 'ER',
      currency: 'ETB',
      footprint: 1.24,
      locale: 'ti-ER',
    },
    {
      name: 'Estonia',
      code: 'EE',
      currency: 'USD',
      footprint: 18.55,
      eu: true,
      locale: 'et-EE',
    },
    {
      name: 'Ethiopia',
      code: 'ET',
      currency: 'ETB',
      footprint: 1.51,
      locale: 'am-ET',
    },
    {
      name: 'Faeroe Islands',
      code: 'FO',
      currency: 'DKK',
      footprint: 13.047817390766, // Eurostats 62.70
      locale: 'fo-FO',
    },
    {
      name: 'Falkland Islands (Malvinas)',
      code: 'FK',
      currency: 'FKP',
      locale: 'en-FK',
    },
    {
      name: 'Fiji',
      code: 'FJ',
      currency: 'FJD',
      footprint: 2.81,
      locale: 'en-FJ',
    },
    {
      name: 'Finland',
      code: 'FI',
      currency: 'EUR',
      footprint: 13.89,
      eu: true,
      locale: 'fi-FI',
    },
    {
      name: 'France',
      code: 'FR',
      currency: 'EUR',
      footprint: 6.98,
      eu: true,
      locale: 'fr-FR',
    },
    {
      name: 'French Guiana',
      code: 'GF',
      currency: 'EUR',
      footprint: 3.3,
      eu: true,
      locale: 'fr-GF',
    },
    {
      name: 'French Polynesia',
      code: 'PF',
      currency: 'XPF',
      footprint: 2.62,
      locale: 'fr-PF',
    },
    {
      name: 'Gabon',
      code: 'GA',
      currency: 'XAF',
      footprint: 7.94,
      locale: 'fr-GA',
    },
    {
      name: 'Gambia',
      code: 'GM',
      currency: 'GMD',
      footprint: 0.26780913418482,
      locale: 'en-GM',
    },
    {
      name: 'Georgia',
      code: 'GE',
      currency: 'GEL',
      footprint: 4.03,
      locale: 'ka-GE',
    },
    {
      name: 'Germany',
      code: 'DE',
      currency: 'EUR',
      footprint: 10.7,
      eu: true,
      locale: 'de-DE',
    },
    {
      name: 'Ghana',
      code: 'GH',
      currency: 'USD',
      footprint: 1.29,
      locale: 'en-GH',
    },
    {
      name: 'Gibraltar',
      code: 'GI',
      currency: 'GIP',
      footprint: 17.4,
      locale: 'en-GI',
    },
    {
      name: 'Greece',
      code: 'GR',
      currency: 'EUR',
      footprint: 9.0,
      eu: true,
      locale: 'el-GR',
    },
    {
      name: 'Greenland',
      code: 'GL',
      currency: 'DKK',
      footprint: 9.72,
      eu: true,
      locale: 'kl-GL',
    },
    {
      name: 'Grenada',
      code: 'GD',
      currency: 'XCD',
      footprint: 3.08,
      locale: 'en-GD',
    },
    {
      name: 'Guadeloupe',
      code: 'GP',
      currency: 'EUR',
      footprint: 6.14,
      locale: 'fr-GP',
    },
    {
      name: 'Guatemala',
      code: 'GT',
      currency: 'GTQ',
      footprint: 2.04,
      locale: 'es-GT',
    },
    {
      name: 'Guinea',
      code: 'GN',
      currency: 'GNF',
      footprint: 1.66,
      locale: 'fr-GN',
    },
    {
      name: 'Guinea-Bissau',
      code: 'GW',
      currency: 'XOF',
      footprint: 1.57,
      locale: 'pt-GW',
    },
    {
      name: 'Guyana',
      code: 'GY',
      currency: 'GYD',
      footprint: 6.42,
      locale: 'en-GY',
    },
    {
      name: 'Haiti',
      code: 'HT',
      currency: 'HTG',
      footprint: 1.29,
      locale: 'ht-HT',
    },
    {
      name: 'Honduras',
      code: 'HN',
      currency: 'HNL',
      footprint: 2.21,
      locale: 'es-HN',
    },
    {
      name: 'Hong Kong',
      code: 'HK',
      currency: 'HKD',
      footprint: 6.87,
      locale: 'zh-HK',
    },
    {
      name: 'Hungary',
      code: 'HU',
      currency: 'HUF',
      footprint: 6.78,
      eu: true,
      locale: 'hu-HU',
    },
    {
      name: 'Iceland',
      code: 'IS',
      currency: 'ISK',
      footprint: 17.5,
      locale: 'is-IS',
    },
    {
      name: 'Indonesia',
      code: 'ID',
      currency: 'IDR',
      footprint: 23.48,
      locale: 'id-ID',
    },
    {
      name: 'Iran',
      code: 'IR',
      currency: 'USD',
      footprint: 10.28,
      locale: 'fa-IR',
    },
    {
      name: 'Iraq',
      code: 'IQ',
      currency: 'USD',
      footprint: 6.59,
      locale: 'ar-IQ',
    },
    {
      name: 'Ireland',
      code: 'IE',
      currency: 'EUR',
      footprint: 13.2,
      eu: true,
      locale: 'en-IE',
    },
    {
      name: 'Israel',
      code: 'IL',
      currency: 'ILS',
      footprint: 10.2,
      locale: 'he-IL',
    },
    {
      name: 'Italy',
      code: 'IT',
      currency: 'EUR',
      footprint: 7.3,
      eu: true,
      locale: 'it-IT',
    },
    {
      name: 'Jamaica',
      code: 'JM',
      currency: 'JMD',
      footprint: 3.6,
      locale: 'en-JM',
    },
    {
      name: 'Japan',
      code: 'JP',
      currency: 'JPY',
      footprint: 10.62,
      locale: 'ja-JP',
    },
    {
      name: 'Jordan',
      code: 'JO',
      currency: 'USD',
      footprint: 3.61,
      locale: 'ar-JO',
    },
    {
      name: 'Kazakhstan',
      code: 'KZ',
      currency: 'KZT',
      footprint: 20.29,
      locale: 'kk-KZ',
    },
    {
      name: 'Kenya',
      code: 'KE',
      currency: 'KES',
      footprint: 1.81,
      locale: 'sw-KE',
    },
    {
      name: 'Kiribati',
      code: 'KI',
      currency: 'AUD',
      footprint: 0.64,
      locale: 'en-KI',
    },
    {
      name: 'Kosovo',
      code: 'KR',
      currency: 'EUR',
      footprint: 4.8159106920284,
      locale: 'sq-XK',
    },
    {
      name: 'Kuwait',
      code: 'KW',
      currency: 'USD',
      footprint: 32.97,
      locale: 'ar-KW',
    },
    {
      name: 'Kyrgyzstan',
      code: 'KG',
      currency: 'KGS',
      footprint: 3.35,
      locale: 'ky-KG',
    },
    {
      name: 'Laos',
      code: 'LA',
      currency: 'LAK',
      footprint: 2.24,
      locale: 'lo-LA',
    },
    {
      name: 'Latvia',
      code: 'LV',
      currency: 'USD',
      footprint: 6.3,
      eu: true,
      locale: 'lv-LV',
    },
    {
      name: 'Lebanon',
      code: 'LB',
      currency: 'LBP',
      footprint: 5.0,
      locale: 'ar-LB',
    },
    {
      name: 'Lesotho',
      code: 'LS',
      currency: 'LSL',
      footprint: 1.31,
      locale: 'en-LS',
    },
    {
      name: 'Liberia',
      code: 'LR',
      currency: 'LRD',
      footprint: 0.84,
      locale: 'en-LR',
    },
    {
      name: 'Libya',
      code: 'LY',
      currency: 'USD',
      footprint: 10.99,
      locale: 'ar-LY',
    },
    {
      name: 'Liechtenstein',
      code: 'LI',
      currency: 'CHF',
      footprint: 4.8,
      locale: 'de-LI',
    },
    {
      name: 'Lithuania',
      code: 'LT',
      currency: 'USD',
      footprint: 7.4,
      eu: true,
      locale: 'lt-LT',
    },
    {
      name: 'Luxembourg',
      code: 'LU',
      currency: 'EUR',
      footprint: 20.3,
      eu: true,
      locale: 'fr-LU',
    },
    {
      name: 'Macao',
      code: 'MO',
      currency: 'MOP',
      footprint: 2.15,
      locale: 'zh-MO',
    },
    {
      name: 'Macedonia (Republic of)',
      code: 'MK',
      currency: 'MKD',
      footprint: 3.4894623364765,
      locale: 'mk-MK',
    },
    {
      name: 'Madagascar',
      code: 'MG',
      currency: 'MGA',
      footprint: 1.2,
      locale: 'mg-MG',
    },
    {
      name: 'Malawi',
      code: 'MW',
      currency: 'MWK',
      footprint: 0.61,
      locale: 'ny-MW',
    },
    {
      name: 'Malaysia',
      code: 'MY',
      currency: 'MYR',
      footprint: 10.37,
      locale: 'ms-MY',
    },
    {
      name: 'Maldives',
      code: 'MV',
      currency: 'MVR',
      footprint: 2.19,
      locale: 'dv-MV',
    },
    {
      name: 'Mali',
      code: 'ML',
      currency: 'XOF',
      footprint: 1.72,
      locale: 'fr-ML',
    },
    {
      name: 'Malta',
      code: 'MT',
      currency: 'USD',
      footprint: 5.5,
      eu: true,
      locale: 'mt-MT',
    },
    {
      name: 'Marshall Islands',
      code: 'MH',
      currency: 'USD',
      footprint: 2.5807611319398,
      locale: 'en-MH',
    },
    {
      name: 'Martinique',
      code: 'MQ',
      currency: 'EUR',
      footprint: 6.75,
      locale: 'fr-MQ',
    },
    {
      name: 'Mauritania',
      code: 'MR',
      currency: 'MRO',
      footprint: 2.87,
      locale: 'ar-MR',
    },
    {
      name: 'Mauritius',
      code: 'MU',
      currency: 'MUR',
      footprint: 3.7,
      locale: 'en-MU',
    },
    {
      name: 'Mexico',
      code: 'MX',
      currency: 'MXN',
      footprint: 6.12,
      locale: 'es-MX',
    },
    {
      name: 'Micronesia (Federated States of)',
      code: 'FM',
      currency: 'USD',
      footprint: 1.3383345170455,
      locale: 'en-FM',
    },
    {
      name: 'Moldova',
      code: 'MD',
      currency: 'MDL',
      footprint: 3.22,
      locale: 'ro-MD',
    },
    {
      name: 'Mongolia',
      code: 'MN',
      currency: 'MNT',
      footprint: 15.25,
      locale: 'mn-MN',
    },
    {
      name: 'Montenegro',
      code: 'ME',
      currency: 'EUR',
      footprint: 3.1990621351398,
      locale: 'sr-ME',
    },
    {
      name: 'Montserrat',
      code: 'MS',
      currency: 'XCD',
      footprint: 5.9645503705187,
      locale: 'en-MS',
    },
    {
      name: 'Morocco',
      code: 'MA',
      currency: 'MAD',
      footprint: 2.42,
      locale: 'ar-MA',
    },
    {
      name: 'Mozambique',
      code: 'MZ',
      currency: 'MZN',
      footprint: 0.93,
      locale: 'pt-MZ',
    },
    {
      name: 'Myanmar',
      code: 'MM',
      currency: 'MMK',
      footprint: 2.48,
      locale: 'my-MM',
    },
    {
      name: 'Namibia',
      code: 'NA',
      currency: 'NAD',
      footprint: 4.69,
      locale: 'en-NA',
    },
    {
      name: 'Nauru',
      code: 'NR',
      currency: 'AUD',
      footprint: 4.7093720712277,
      locale: 'en-NR',
    },
    {
      name: 'Nepal',
      code: 'NP',
      currency: 'NPR',
      footprint: 1.46,
      locale: 'ne-NP',
    },
    {
      name: 'Netherlands',
      code: 'NL',
      currency: 'EUR',
      footprint: 11.6,
      eu: true,
      locale: 'nl-NL',
    },
    {
      name: 'New Caledonia',
      code: 'NC',
      currency: 'XPF',
      footprint: 21.64,
      locale: 'fr-NC',
    },
    {
      name: 'Nicaragua',
      code: 'NI',
      currency: 'NIO',
      footprint: 3.07,
      locale: 'es-NI',
    },
    {
      name: 'Niger',
      code: 'NE',
      currency: 'XOF',
      footprint: 1.61,
      locale: 'fr-NE',
    },
    {
      name: 'Nigeria',
      code: 'NG',
      currency: 'NGN',
      footprint: 1.71,
      locale: 'en-NG',
    },
    {
      name: 'Niue',
      code: 'NU',
      currency: 'NZD',
      footprint: 4.772037037037,
      locale: 'en-NU',
    },
    {
      name: 'North Korea',
      code: 'NF',
      currency: 'AUD',
      footprint: 2.09,
      locale: 'ko-KP',
    },
    {
      name: 'Norway',
      code: 'NO',
      currency: 'NOK',
      footprint: 10.1,
      locale: 'nb-NO',
    },
    {
      name: 'Occupied Palestinian Territory',
      code: 'PS',
      currency: 'USD',
      footprint: 0.65998639928324,
      locale: 'ar-PS',
    },
    {
      name: 'Oman',
      code: 'OM',
      currency: 'USD',
      footprint: 24.88,
      locale: 'ar-OM',
    },
    {
      name: 'Pakistan',
      code: 'PK',
      currency: 'PKR',
      footprint: 2.14,
      locale: 'ur-PK',
    },
    {
      name: 'Palau',
      code: 'PW',
      currency: 'USD',
      footprint: 13.167476405875,
      locale: 'en-PW',
    },
    {
      name: 'Panama',
      code: 'PA',
      currency: 'PAB',
      footprint: 4.21,
      locale: 'es-PA',
    },
    {
      name: 'Papua New Guinea',
      code: 'PG',
      currency: 'PGK',
      footprint: 0.94,
      locale: 'en-PG',
    },
    {
      name: 'Paraguay',
      code: 'PY',
      currency: 'PYG',
      footprint: 6.03,
      locale: 'es-PY',
    },
    {
      name: 'Peru',
      code: 'PE',
      currency: 'PEN',
      footprint: 2.8,
      locale: 'es-PE',
    },
    {
      name: 'Philippines',
      code: 'PH',
      currency: 'PHP',
      footprint: 2.05,
      locale: 'fil-PH',
    },
    {
      name: 'Poland',
      code: 'PL',
      currency: 'PLN',
      footprint: 11.0,
      eu: true,
      locale: 'pl-PL',
    },
    {
      name: 'Portugal',
      code: 'PT',
      currency: 'EUR',
      footprint: 7.0,
      eu: true,
      locale: 'pt-PT',
    },
    {
      name: 'Qatar',
      code: 'QA',
      currency: 'QAR',
      footprint: 37.970875175523,
      locale: 'ar-QA',
    },
    {
      name: 'Republic of South Sudan',
      code: 'SS',
      currency: 'QAR',
      footprint: 0.17040929663617,
      locale: 'en-SS',
    },
    {
      name: 'Réunion',
      code: 'RE',
      currency: 'EUR',
      footprint: 3.88,
      locale: 'fr-RE',
    },
    {
      name: 'Romania',
      code: 'RO',
      currency: 'RON',
      footprint: 6.0,
      eu: true,
      locale: 'ro-RO',
    },
    {
      name: 'Russian Federation',
      code: 'RU',
      currency: 'RUB',
      footprint: 15.53,
      locale: 'ru-RU',
    },
    {
      name: 'Rwanda',
      code: 'RW',
      currency: 'RWF',
      footprint: 0.55,
      locale: 'rw-RW',
    },
    {
      name: 'Saint Helena',
      code: 'SH',
      currency: 'GBP',
      footprint: 4.36,
      locale: 'en-SH',
    },
    {
      name: 'Saint Kitts and Nevis',
      code: 'KN',
      currency: 'XCD',
      footprint: 4.88,
      locale: 'en-KN',
    },
    {
      name: 'Saint Lucia',
      code: 'LC',
      currency: 'XCD',
      footprint: 2.71,
      locale: 'en-LC',
    },
    {
      name: 'Saint Pierre and Miquelon',
      code: 'PM',
      currency: 'EUR',
      footprint: 13.15,
      locale: 'fr-PM',
    },
    {
      name: 'Saint Vincent and the Grenadines',
      code: 'VC',
      currency: 'XCD',
      footprint: 2.22,
      locale: 'en-VC',
    },
    {
      name: 'Samoa',
      code: 'WS',
      currency: 'EUR',
      footprint: 1.85,
      locale: 'sm-WS',
    },
    {
      name: 'Sao Tome and Principe',
      code: 'ST',
      currency: 'STD',
      footprint: 1.23,
      locale: 'pt-ST',
    },
    {
      name: 'Saudi Arabia',
      code: 'SA',
      currency: 'SAR',
      footprint: 22.49,
      locale: 'ar-SA',
    },
    {
      name: 'Senegal',
      code: 'SN',
      currency: 'XOF',
      footprint: 1.5,
      locale: 'fr-SN',
    },
    {
      name: 'Serbia',
      code: 'RS',
      currency: 'RSD',
      footprint: 8.1,
      locale: 'sr-RS',
    },
    {
      name: 'Seychelles',
      code: 'SC',
      currency: 'SCR',
      footprint: 10.43,
      locale: 'en-SC',
    },
    {
      name: 'Sierra Leone',
      code: 'SL',
      currency: 'SLL',
      footprint: 0.85,
      locale: 'en-SL',
    },
    {
      name: 'Singapore',
      code: 'SG',
      currency: 'SGD',
      footprint: 10.54,
      locale: 'en-SG',
    },
    {
      name: 'Slovakia',
      code: 'SK',
      currency: 'USD',
      footprint: 8.0,
      eu: true,
      locale: 'sk-SK',
    },
    {
      name: 'Slovenia',
      code: 'SI',
      currency: 'EUR',
      footprint: 8.5,
      eu: true,
      locale: 'sl-SI',
    },
    {
      name: 'Solomon Islands',
      code: 'SB',
      currency: 'SBD',
      footprint: 0.51,
      locale: 'en-SB',
    },
    {
      name: 'Somalia',
      code: 'SO',
      currency: 'SOS',
      footprint: 1.99,
      locale: 'so-SO',
    },
    {
      name: 'South Korea',
      code: 'GS',
      currency: 'GBP',
      footprint: 13.92,
      locale: 'ko-KR',
    },
    {
      name: 'Spain',
      code: 'ES',
      currency: 'EUR',
      footprint: 7.5,
      eu: true,
      locale: 'es-ES',
    },
    {
      name: 'Sri Lanka',
      code: 'LK',
      currency: 'LKR',
      footprint: 1.71,
      locale: 'si-LK',
    },
    {
      name: 'Sudan',
      code: 'SD',
      currency: 'USD',
      footprint: 2.37,
      locale: 'ar-SD',
    },
    {
      name: 'Suriname',
      code: 'SR',
      currency: 'SRD',
      footprint: 5.43,
      locale: 'nl-SR',
    },
    {
      name: 'Swaziland',
      code: 'SZ',
      currency: 'SZL',
      footprint: 1.054932714707,
      locale: 'en-SZ',
    },
    {
      name: 'Sweden',
      code: 'SE',
      currency: 'SEK',
      footprint: 5.4,
      eu: true,
      locale: 'sv-SE',
    },
    {
      name: 'Switzerland',
      code: 'CH',
      currency: 'CHF',
      footprint: 6.1,
      locale: 'de-CH',
    },
    {
      name: 'Syria',
      code: 'SY',
      currency: 'CHF',
      footprint: 2.41,
      locale: 'ar-SY',
    },
    {
      name: 'Taiwan',
      code: 'TW',
      currency: 'TWD',
      footprint: 12.96,
      locale: 'zh-TW',
    },
    {
      name: 'Tajikistan',
      code: 'TJ',
      currency: 'TJS',
      footprint: 1.8,
      locale: 'tg-TJ',
    },
    {
      name: 'Tanzania',
      code: 'TZ',
      currency: 'TZS',
      footprint: 1.43,
      locale: 'sw-TZ',
    },
    {
      name: 'Thailand',
      code: 'TH',
      currency: 'THB',
      footprint: 5.78,
      locale: 'th-TH',
    },
    {
      name: 'Timor-Leste',
      code: 'TP',
      currency: 'IDR',
      footprint: 1.08,
      locale: 'pt-TL',
    },
    {
      name: 'Togo',
      code: 'TG',
      currency: 'XOF',
      footprint: 1.1,
      locale: 'fr-TG',
    },
    {
      name: 'Tonga',
      code: 'TO',
      currency: 'TOP',
      footprint: 1.95,
      locale: 'to-TO',
    },
    {
      name: 'Trinidad and Tobago',
      code: 'TT',
      currency: 'TTD',
      footprint: 37.38,
      locale: 'en-TT',
    },
    {
      name: 'Tunisia',
      code: 'TN',
      currency: 'USD',
      footprint: 3.66,
      locale: 'ar-TN',
    },
    {
      name: 'Turkey',
      code: 'TR',
      currency: 'TRY',
      footprint: 6.5,
      locale: 'tr-TR',
    },
    {
      name: 'Turkmenistan',
      code: 'TM',
      currency: 'USD',
      footprint: 22.23,
      locale: 'tk-TM',
    },
    {
      name: 'Turks and Caicos Islands',
      code: 'TC',
      currency: 'USD',
      footprint: 5.2,
      locale: 'en-TC',
    },
    {
      name: 'Tuvalu',
      code: 'TV',
      currency: 'AUD',
      footprint: 1.0076468543622,
      locale: 'en-TV',
    },
    {
      name: 'Uganda',
      code: 'UG',
      currency: 'UGX',
      footprint: 1.1,
      locale: 'en-UG',
    },
    {
      name: 'Ukraine',
      code: 'UA',
      currency: 'UAH',
      footprint: 6.59,
      locale: 'uk-UA',
    },
    {
      name: 'United Arab Emirates',
      code: 'AE',
      currency: 'AED',
      footprint: 26.94,
      locale: 'ar-AE',
    },
    {
      name: 'Uruguay',
      code: 'UY',
      currency: 'UYU',
      footprint: 11.65,
      locale: 'es-UY',
    },
    {
      name: 'Uzbekistan',
      code: 'UZ',
      currency: 'UZS',
      footprint: 5.6,
      locale: 'uz-UZ',
    },
    {
      name: 'Vanuatu',
      code: 'VU',
      currency: 'VUV',
      footprint: 2.26,
      locale: 'bi-VU',
    },
    {
      name: 'Venezuela',
      code: 'VE',
      currency: 'USD',
      footprint: 8.17,
      locale: 'es-VE',
    },
    {
      name: 'Vietnam',
      code: 'VN',
      currency: 'VND',
      footprint: 3.59,
      locale: 'vi-VN',
    },
    {
      name: 'Wallis and Futuna Islands',
      code: 'WF',
      currency: 'XPF',
      footprint: 2.3202984306663,
      locale: 'fr-WF',
    },
    {
      name: 'Western Sahara',
      code: 'EH',
      currency: 'MAD',
      footprint: 1.58,
      locale: 'ar-EH',
    },
    {
      name: 'Yemen',
      code: 'YE',
      currency: 'YER',
      footprint: 1.2,
      locale: 'ar-YE',
    },
    {
      name: 'Zambia',
      code: 'ZM',
      currency: 'USD',
      footprint: 1.47,
      locale: 'en-ZM',
    },
    {
      name: 'Zimbabwe',
      code: 'ZW',
      currency: 'USD',
      footprint: 1.89,
      locale: 'en-ZW',
    },
  ],
};

export const getDataByCountryCode = (code?: string) => {
  return countryData.countries.find((country) => country.code === code?.toUpperCase());
};

export const countryUsesImperialUnits = (code: string) =>
  countryData.countries.find((country) => country.code === code.toUpperCase())?.unitSystem === 'IMPERIAL';

export const getDataByCountryName = (name: string) =>
  countryData.countries.find((country) => country.name.toUpperCase() === name.toUpperCase());

export const getDataByCountryCurrency = (currency: string) =>
  countryData.countries.find((country) => country.currency === currency);

export const getCountryCount = countryData.countries.length;

export const getCountryName = (countryCode: string) => {
  const country = getDataByCountryCode(countryCode.toUpperCase());
  return country ? country.name : "Unknown";
};

export const getCountryCodeFromName = (countryName: string) => {
  const countryCode = getDataByCountryName(countryName.toUpperCase());
  return countryCode ? countryCode.code : "XX";
};

export default getDataByCountryCode;
